import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Login: BleskIcon = forwardRef(function Check(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        d="M2.99658 12H14.0012"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9995 8.99872L14.0008 12L10.9995 15.0012"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99756 9.13579V7.39807C5.99813 6.44467 6.67133 5.62411 7.60623 5.43725L18.6108 3.03025C19.225 2.9593 19.8399 3.15657 20.2982 3.57156C20.7565 3.98655 21.0137 4.57897 21.0038 5.19715V19.0029C21.0041 19.593 20.7438 20.1532 20.2927 20.5336C19.8415 20.9139 19.2454 21.0757 18.6638 20.9757L7.65925 19.0829C6.69882 18.9178 5.9971 18.0846 5.99756 17.1101V14.9722"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
